var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80273 9.46973C5.91992 9.46973 6.02539 9.43457 6.14258 9.31738L8.12305 7.40137C8.21094 7.31348 8.25781 7.21973 8.25781 7.09668C8.25781 6.85645 8.07617 6.68652 7.83008 6.68652C7.71875 6.68652 7.5957 6.7334 7.51367 6.82715L6.62891 7.77051L6.23047 8.18652L6.26562 7.30762V1.13184C6.26562 0.885742 6.05469 0.674805 5.80273 0.674805C5.55078 0.674805 5.33398 0.885742 5.33398 1.13184V7.30762L5.375 8.18652L4.97656 7.77051L4.08594 6.82715C4.00391 6.7334 3.88086 6.68652 3.76367 6.68652C3.52344 6.68652 3.3418 6.85645 3.3418 7.09668C3.3418 7.21973 3.39453 7.31348 3.48242 7.40137L5.46289 9.31738C5.58008 9.43457 5.68555 9.46973 5.80273 9.46973ZM2.43945 13.3252H9.16016C10.3848 13.3252 11 12.7158 11 11.5088V5.66113C11 4.4541 10.3848 3.84473 9.16016 3.84473H7.52539V4.78809H9.14258C9.72266 4.78809 10.0566 5.10449 10.0566 5.71387V11.4561C10.0566 12.0654 9.72266 12.3818 9.14258 12.3818H2.45117C1.86523 12.3818 1.54297 12.0654 1.54297 11.4561V5.71387C1.54297 5.10449 1.86523 4.78809 2.45117 4.78809H4.07422V3.84473H2.43945C1.21484 3.84473 0.599609 4.4541 0.599609 5.66113V11.5088C0.599609 12.7158 1.21484 13.3252 2.43945 13.3252Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.0b13ce69489f17954c0b8db7a3d02417.svg";
export { ForwardRef as ReactComponent };